import type AttendeePersonaProps from 'owa-readwrite-recipient-well-fabric/lib/store/schema/AttendeePersonaProps';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getReadWriteRecipientViewStateFromEmailAddress } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromEmailAddress';
import { getReadWriteRecipientViewStateFromFindRecipientPersonaType } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromFindRecipientPersonaType';
import type ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';

export function convertRecipientsToAttendees(
    recipients: ReadWriteRecipientViewState[]
): AttendeePersonaProps[] {
    return recipients
        ? recipients.map(
              recipient =>
                  <AttendeePersonaProps>{
                      Mailbox: recipient.persona.EmailAddress,
                      persona: recipient.persona,
                  }
          )
        : [];
}

export function convertAttendeesToEmailAddressWrappers(
    attendees?: AttendeeType[]
): EmailAddressWrapper[] {
    return attendees
        ? attendees.filter(attendee => !!attendee.Mailbox).map(attendee => attendee.Mailbox!)
        : [];
}

type AttendeeAllTypes = AttendeeType | AttendeePersonaProps;

export function convertAttendeesToRecipientWellViewStates(
    attendees?: AttendeeAllTypes[]
): ReadWriteRecipientViewState[] {
    return attendees
        ? attendees
              .filter(attendee => 'persona' in attendee || !!attendee.Mailbox)
              .map(attendee => {
                  if ('persona' in attendee) {
                      return getReadWriteRecipientViewStateFromFindRecipientPersonaType(
                          attendee.persona
                      );
                  }
                  return getReadWriteRecipientViewStateFromEmailAddress(attendee.Mailbox!);
              })
        : [];
}
